module.exports = __webpack_public_path__ + "img/icon-name-詠馨.11cec748.png";